export enum PLAN_TYPES {
  FREE = 'FREE',
  BASIC = 'BASIC',
  PRO = 'PRO',
}

export const PLANS_HIERARCHY: Array<keyof typeof PLAN_TYPES> = [
  PLAN_TYPES.FREE,
  PLAN_TYPES.BASIC,
  PLAN_TYPES.PRO,
];

export enum OLD_PRICES {
  FREE = 0,
  BASIC = 18,
  PRO = 30,
}

export const PRICING_CARD_CURRENT_PLAN_BUTTON_TITLE = 'Edit plan';
export const PRICING_CARD_UPGRADE_BUTTON_TITLE = 'Upgrade';
export const PRICING_CARD_DOWNGRADE_BUTTON_TITLE = 'Downgrade';
export const PRICING_CARD_CANCEL_BUTTON_TITLE = 'Cancel';

export const CURRENT_PLAN_TEXT = 'Current Plan';

export const PRICING_CARD_CURRENCY_SYMBOL = '$';
export const PRICING_CARD_FREE_PLAN_LABEL = 'Free';

export const PLAN_ICON_SIZE = '10rem';
